module.exports = __webpack_public_path__ + "static/media/logo-dktn.ec7b2939.jpg";